module.exports = __webpack_public_path__ + "assets/img/build.c37909eb.png";